import { Base } from "ui/Scripts/source/framework/base";
import { IListItems, ListItems } from "ui/Scripts/source/framework/listItems";
import { CompanyListItem, ICompanyListItem } from "./companyListItem";

export interface ICompanyListItems extends IListItems<ICompanyListItem> {}

export class CompanyListItems extends ListItems<CompanyListItem> implements ICompanyListItems {
    constructor();
    constructor(obj: ICompanyListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, CompanyListItem);
    }
}